<template>
  <div class="quicklinks">
    <div class="ql-row">
      <div class="left">
        <div class="icon" v-html="items[0].icon"></div>
        <div class="ql-label" v-html="items[0].label"></div>
      </div>
      <div class="right">
        <DeployerUiColorModeSwitcher />
      </div>
    </div>
    <NuxtLink to="/account/plan/" class="ql-row link">
      <div class="left">
        <div class="icon" v-html="items[1].icon"></div>
        <div class="ql-label" v-html="items[1].label"></div>
      </div>
      <div class="right">
        <div class="chevron" v-html="ChevronRightSvg"></div>
      </div>
    </NuxtLink>
    <NuxtLink to="/account/team/" class="ql-row link">
      <div class="left">
        <div class="icon" v-html="items[2].icon"></div>
        <div class="ql-label" v-html="items[2].label"></div>
      </div>
      <div class="right">
        <DeployerAccountTeamInitials />
        <div class="chevron" v-html="ChevronRightSvg"></div>
      </div>
    </NuxtLink>

    <NuxtLink to="/account/support/" class="ql-row link">
      <div class="left">
        <div class="icon" v-html="items[3].icon"></div>
        <div class="ql-label" v-html="items[3].label"></div>
      </div>
      <div class="right">
        <div class="chevron" v-html="ChevronRightSvg"></div>
      </div>
    </NuxtLink>
    <NuxtLink to="/account/billing/" class="ql-row link">
      <div class="left">
        <div class="icon" v-html="items[4].icon"></div>
        <div class="ql-label" v-html="items[4].label"></div>
      </div>
      <div class="right">
        <div class="chevron" v-html="ChevronRightSvg"></div>
      </div>
    </NuxtLink>
  </div>
</template>

<script setup>
import ChevronRightSvg from '~/layers/base/assets/icons/chevron-right.svg?raw'

const textsStore = useTextsStore()

const items = computed(() => textsStore.account.general.box_2.items)
</script>

<style lang="scss" scoped>
.quicklinks {
  border-radius: 10px;
  border: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
}

.ql-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  min-height: 60px;
  border-bottom: 1px solid var(--bubble-10, rgba(0, 0, 0, 0.1));
  font-size: 1.5rem;
  color: var(--Text, #000);
  font-weight: 500;

  .icon {
    width: 24px;
    opacity: 0.5;
    :deep(svg) {
      path {
        stroke: var(--Text, #000);
      }
    }

    @media (max-width: 400px) {
      display: none;
    }
  }

  .left,
  .right {
    display: flex;
    align-items: center;
  }

  .left {
    gap: 10px;
  }

  .right {
    justify-content: flex-end;
    gap: 20px;
  }

  &:last-child {
    border-bottom: none;
  }

  &.link {
    .chevron {
      transition: transform 0.3s;
      :deep(path) {
        stroke: var(--Text, #000);
      }
    }
    &:hover {
      .chevron {
        transform: translateX(5px);
      }
    }
  }
}
</style>
